import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const RESOURCE_PATH = `${BASE_PATH_API}/trialWalkthroughs`;

const actions = {
    saveUserProgress: {
        method: 'PUT',
        url: `${RESOURCE_PATH}/settings/progress`
    },
    getUserSettings: {
        method: 'GET',
        url: `${RESOURCE_PATH}/settings`
    }
};

export const TrialWalkthroughApi = createActions(actions);
